import React from 'react';
import { Box, Button, EditIcon, Text } from '@razorpay/blade/components';
import { ModalActions } from '../constants';

const EnableDisableComponentButton = ({
  isActive,
  openModal,
}: {
  isActive: boolean;
  openModal: (modalAction: string) => void;
}) => {
  return isActive ? (
    <Button
      variant={'tertiary'}
      isFullWidth={true}
      onClick={() => openModal(ModalActions.disable)}
      accessibilityLabel="details view disable button">
      Disable
    </Button>
  ) : (
    <Button
      variant={'secondary'}
      color={'positive'}
      isFullWidth={true}
      onClick={() => openModal(ModalActions.enable)}
      accessibilityLabel="details view enable button">
      Enable
    </Button>
  );
};

export const ModalActionButtons = ({
  isActive,
  showEnableDisableButton,
  openModal,
  onEditClick,
  note,
}: {
  isActive: boolean;
  showEnableDisableButton: boolean;
  openModal: (modalAction: string) => void;
  onEditClick: (e: React.MouseEvent) => void;
  note?: string;
}) => {
  return (
    <Box>
      <Box
        display={'grid'}
        gridTemplateColumns={showEnableDisableButton ? '0.60fr 0.40fr' : '1fr'}
        columnGap={'spacing.4'}>
        <Button variant={'primary'} icon={EditIcon} iconPosition={'left'} isFullWidth={true} onClick={onEditClick}>
          Modify
        </Button>
        {showEnableDisableButton && (
          <EnableDisableComponentButton isActive={isActive} openModal={openModal} />
        )}
        {!showEnableDisableButton && (
          <Box marginTop="spacing.3">
            <Text size="small" color="surface.text.gray.muted">
              This is the default salary structure for your organisation and cannot be disabled
            </Text>
          </Box>
        )}
      </Box>
      {note && (
        <Box marginTop="spacing.4">
          <Text size="medium" color="surface.text.gray.muted">
            <Text as="span" size="medium" color="surface.text.gray.normal">
              Note:{' '}
            </Text>
            {note}
          </Text>
        </Box>
      )}
      {/* Temporarily commenting it out till we solutionise salary component deletion */}
      {/* <Box display={'flex'} justifyContent={'center'}>
        <Link
          marginTop={'spacing.7'}
          marginBottom={'spacing.8'}
          variant={'button'}
          icon={TrashIcon}
          iconPosition={'left'}
          color={'negative'}
          onClick={() => openModal(ModalActions.delete)}
          accessibilityLabel="details view delete button">
          Delete component
        </Link>
      </Box> */}
    </Box>
  );
};
